const lang = {
    months : "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    monthsShort : "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    weekdays : "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    weekdaysShort : "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    longDateFormat : {
        LT : "h:mm A",
        L : "DD/MM/YYYY",
        LL : "D MMMM YYYY",
        LLL : "D MMMM YYYY LT",
        LLLL : "dddd, D MMMM YYYY LT"
    },
    meridiem : false,
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        fullFormat: {
            future: "%s left",
            past: "%s ago",
            s: "< 1 min",
            m: "1 min",
            mm: "%d mins",
            h: "1 hour",
            hm: "%d hour, %d min",
            hmm: "%d hour, %d mins",
            hh: "%d hours",
            hhm: "%d hours, %d min",
            hhmm: "%d hours, %d mins",
            d: "%d day",
            dh: "%d day, %d hour",
            dhh: "%d day, %d hours",
            dd: "%d days",
            ddh: "%d days, %d hour",
            ddhh: "%d days, %d hours",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yM: "%d year, %d month",
            yMM: "%d year, %d months",
            yy: "%d years",
            yyM: "%d years, %d month",
            yyMM: "%d years, %d months"
        },
        shortFormat: {
            future: "%s left",
            past: "%s ago",
            s: "< 1m",
            m: "1m",
            mm: "%dm",
            h: "1h",
            hm: "%dh, %dm",
            hmm: "%dh, %dm",
            hh: "%dh",
            hhm: "%dh, %dm",
            hhmm: "%dh, %dm",
            d: "%dd",
            dh: "%dd, %dh",
            dhh: "%dd, %dh",
            dd: "%dd",
            ddh: "%dd, %dh",
            ddhh: "%dd, %dh",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yM: "%d year, %d month",
            yMM: "%d year, %d months",
            yy: "%d years",
            yyM: "%d years, %d month",
            yyMM: "%d years, %d months"
        }
    },
    ordinal : function (number) {
        var b = number % 10;
        return (~~ (number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
    }
};

export default lang;



// WEBPACK FOOTER //
// ./src/web/js/app/lib/moment/lang/en-gb.js